import script from "./CheckUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckUpload.vue?vue&type=script&setup=true&lang=js"

import "./CheckUpload.vue?vue&type=style&index=0&id=340f3f9e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-340f3f9e"]])

export default __exports__